import { FaCartShopping, FaComputer, FaWallet } from "react-icons/fa6";
import { HiShoppingBag } from "react-icons/hi2";
import { MdBusinessCenter, MdDashboard } from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";
import { FaUserCog, FaCode, FaCreditCard } from "react-icons/fa";
import { BsCalendar2EventFill } from "react-icons/bs";
import { GiWallet } from "react-icons/gi";
import { HiReceiptRefund } from "react-icons/hi2";
import { MdDeliveryDining } from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import { RiShoppingBag3Fill } from "react-icons/ri";

export const getSidebarMenus = (activeBusiness, userBusinesses) => {
  const activeBusinessObject = userBusinesses?.find(
    (business) => business.id === activeBusiness
  );
  const categories = activeBusinessObject?.Categories?.map((category) =>
    category.categoryName.toLowerCase()
  );

  return [
    {
      title: "Dashboard",
      route: "/dashboard",
      icon: <MdDashboard className="text-xl" />,
      permission: "1",
    },
    {
      title: "Business Management",
      route: "/business-management",
      icon: <MdBusinessCenter className="text-xl" />,
      permission: "2",
    },
    {
      // title: "Product Orders",
      title: "Transactions",
      route: "/orders",
      // icon: <FaCartShopping className="text-lg" />,
      icon: <GrTransaction className="text-lg" />,
      permission: "3",
    },

    // categories?.includes("delivery") && {
    //   title: "Delivery",
    //   route: "/delivery",
    //   icon: <MdDeliveryDining className="text-xl" />,
    //   permission: "3",
    // },

    categories?.includes("shopping") && {
      title: "Shopping",
      route: "/products",
      icon: <RiShoppingBag3Fill className="text-xl" />,
      permission: "3",
    },

    categories?.includes("event") && {
      title: "Events",
      route: "/events",
      icon: <BsCalendar2EventFill className="text-xl" />,
      permission: "3",
    },

    {
      title: "Refund Requests",
      route: "/refunds",
      icon: <HiReceiptRefund className="text-xl" />,
      permission: "7",
    },
    {
      title: "Wallet",
      route: "/wallet",
      icon: <GiWallet className="text-xl" />,
      permission: "6",
    },
    {
      title: "System Management",
      icon: <FaComputer className="text-xl" />,
      parentRoute: "/system",
      permission: "7",
      children: [
        {
          title: "User Management",
          route: "/system/user-management",
          icon: <FaUserCog className="text-xl" />,
          permission: "5",
        },
        {
          title: "Roles & Permissions",
          permission: "8",
          route: "/system/permissions",
        },
        {
          title: "Audit Logs",
          permission: "7",
          route: "/system/auditlogs",
        },
      ],
    },
    {
      title: "Reports & Analytics",
      route: "/reports",
      icon: <BiSolidReport className="text-xl" />,
      permission: "4",
    },
    {
      title: "Integrations",
      icon: <FaCode className="text-xl" />,
      parentRoute: "/integrations",
      permission: "1",
      children: [
        {
          title: "Payment Settings",
          route: "/payment-integration",
          icon: <FaCreditCard className="text-base" />,
          permission: "1",
        },
        {
          title: "Integration Guide",
          route: "/integration-guide",
          icon: <FaCode className="text-base" />,
          permission: "1",
        },
      ],
    },
  ].filter(Boolean);
};
